import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { isArchive, isTrash } from '../../helpers/App';
import { getSetting } from '../../helpers/Settings';

const CollectionsBreadcrumbs = ({
  collection, share, inSearch, showCollectionTitle,
}) => {
  const intl = useIntl();

  const getUrlPrefix = () => {
    if (isArchive()) {
      return '/archive';
    }
    if (isTrash()) {
      return '/trash';
    }
    return '';
  };

  const getTitle = () => {
    if (isTrash()) {
      return intl.formatMessage({ defaultMessage: 'Trash' });
    }
    if (getSetting('cs1')) {
      return intl.formatMessage({ defaultMessage: 'Browse Categories' });
    }
    return intl.formatMessage({ defaultMessage: 'All Collections' });
  };

  const ancestors = collection.ancestors ? [...collection.ancestors] : [];

  const shareUrl = share ? `/shares/${share.uuid}` : '';
  const firstParent = ancestors[0];
  const lastParent = ancestors.slice(-1)[0];
  const dotsCollections =
    ancestors.filter(c => (c.uuid !== firstParent.uuid && c.uuid !== lastParent.uuid));

  return (
    <div className="collections-breadcrumbs">
      {(!share && (!firstParent || firstParent.uuid !== '-1')) && (
        <>
          {inSearch ? (
            <>
              <span>
                {getTitle()}
              </span>
              <i className="fal fa-chevron-right" />
            </>
          ) : (
            <>
              <Link to={`${getUrlPrefix()}/collections`}>
                {getTitle()}
              </Link>
              <i className="fal fa-chevron-right" />
            </>
          )}
          {' '}
        </>
      )}
      {firstParent && (
        <>
          {inSearch ? (
            <>
              <span>{firstParent.name}</span>
              <i className="fal fa-chevron-right" />
            </>
          ) : (
            <>
              <Link to={`${shareUrl}${getUrlPrefix()}/${firstParent.uuid ? 'collections/' : ''}${firstParent.uuid === '-1' ? 'my' : firstParent.uuid}`}>{firstParent.name}</Link>
              <i className="fal fa-chevron-right" />
            </>
          )}
        </>
      )}
      {dotsCollections.length > 0 && (
        <>
          <UncontrolledDropdown>
            <DropdownToggle tag="span" className="collections-breadcrumbs-dots">
              ...
            </DropdownToggle>
            <DropdownMenu>
              {dotsCollections.map(ca => (
                <DropdownItem key={ca.uuid} tag={inSearch ? 'span' : Link} to={`${shareUrl}${getUrlPrefix()}/collections/${ca.uuid}`}>
                  {ca.name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
          <i className="fal fa-chevron-right" />
        </>
      )}
      {ancestors.length > 1 && (
        <>
          {' '}
          {inSearch ? (
            <>
              <span>{lastParent.name}</span>
              <i className="fal fa-chevron-right" />
            </>
          ) : (
            <>
              <Link to={`${shareUrl}${getUrlPrefix()}/collections/${lastParent.uuid}`}>{lastParent.name}</Link>
              <i className="fal fa-chevron-right" />
            </>
          )}
        </>
      )}
      {showCollectionTitle && <span className="collections-breadcrumbs-active">{collection.name}</span>}
    </div>
  );
};

CollectionsBreadcrumbs.propTypes = {
  collection: PropTypes.object.isRequired,
  share: PropTypes.object,
  inSearch: PropTypes.bool,
  showCollectionTitle: PropTypes.bool,
};

CollectionsBreadcrumbs.defaultProps = {
  share: null,
  inSearch: false,
  showCollectionTitle: false,
};

export default CollectionsBreadcrumbs;
